import { Box } from "@primer/react";
import { useMemo } from "react";
import DataGrid from "../../components/ui/data-grid";
import { IDataGridColumn } from "../../components/ui/data-grid/type/IDataGridProps";

interface Props {
    hocSinhs: any[];
    selectedStudentIds: number[];
    setSelectedStudentIds: React.Dispatch<React.SetStateAction<number[]>>;
}

const MeetingPickGrid = ({
    hocSinhs,
    selectedStudentIds,
    setSelectedStudentIds
}: Props) => {

    const toggleStudent = (studentId: number) => {
        setSelectedStudentIds(prev => {
            if (prev.includes(studentId)) {
                return prev.filter(x => x !== studentId);
            }

            return [...prev, studentId];
        });
    };

    const columns: IDataGridColumn[] = useMemo(() => {
        return [
            {
                dataField: "ma_hs",
                caption: "Mã học sinh",
                width: 150,
                fixed: "left"
            },
            {
                dataField: "ho_ten",
                caption: "Họ tên",
                width: 250,
                fixed: "left"
            },
            {
                dataField: "ten_lop",
                caption: "Lớp",
                width: 120
            },
            {
                dataField: "selected",
                caption: "Chọn",
                width: 100,
                align: "center",
                cellRender: (row: any) => {

                    const checked = selectedStudentIds.includes(row.id);

                    return (
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100%"
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={checked}
                                onChange={() => toggleStudent(row.id)}
                            />
                        </Box>
                    );
                }
            }
        ];
    }, [selectedStudentIds]);

    return (
        <DataGrid
            columns={columns}
            dataSource={hocSinhs}
            searchEnable
        />
    );
};

export default MeetingPickGrid;